import React, { Dispatch, SetStateAction } from 'react';
import { Stack, Flex, Box } from '@chakra-ui/react';
import { Button } from '@landsvirkjun/react.common';

type FormHeaderProps = {
  isSubmitting: boolean;
  previewMode: boolean;
  editMode: boolean;
  id: string | null;
  status: string | undefined;
  onOpen: () => void;
  onCancel: () => void;
  setSkipValidation: Dispatch<SetStateAction<boolean>>;
};

export const FormActionBar = ({
  isSubmitting,
  previewMode,
  editMode,
  status,
  onOpen,
  onCancel,
  setSkipValidation,
}: FormHeaderProps): JSX.Element => {
  return (
    <Flex
      flexWrap={{ base: 'wrap', md: 'nowrap' }}
      justify="space-between"
      pt={5}
      pb={5}
      backgroundColor="white"
      direction="row"
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      padding={'20px 25px'}
      zIndex={1}
      boxShadow={'0 0 20px rgba(0, 0, 0, 0.15)'}
    >
      <Box flexGrow={{ base: 1, md: 0 }} marginLeft="auto">
        <Stack direction="row" style={{ float: 'right' }}>
          {(!previewMode || status === 'DRAFT' || editMode) && (
            <Button
              type="button"
              onClick={(): void => {
                if (editMode) {
                  onCancel();
                } else {
                  onOpen();
                  setSkipValidation(true);
                }
              }}
              variant="warning"
              name="save-form"
            >
              Hætta við
            </Button>
          )}
          <Button
            width="150px"
            type="submit"
            variant="primary"
            isLoading={isSubmitting}
            loadingText="Augnablik..."
            name="submit-form"
          >
            {editMode ? 'Uppfæra beiðni' : 'Stofna beiðni'}
          </Button>
        </Stack>
      </Box>
    </Flex>
  );
};
